import gql from "graphql-tag";
const MY_FAVORITES = gql`
  query (
    $where: FavoritesFilterInput
    $order: [FavoritesSortInput!]
    $skip: Int
    $take: Int
  ) {
    myFavorites(where: $where, order: $order, skip: $skip, take: $take) {
      __pageInfo: pageInfo {
        hasNextPage
      }
      __items: items {
        id
        name
      }
    }
  }
`;
const ADD_OR_EDIT_FAVORITE = gql`
  mutation ($input: FavoritesInput!) {
    addOrEditFavorite(input: $input) {
      id
    }
  }
`;
const ADD_OR_EDIT_FAVORITES = gql`
  mutation ($inputs: [FavoritesInput!]!) {
    addOrEditFavorites(inputs: $inputs) {
      id
    }
  }
`;
export {
  ADD_OR_EDIT_FAVORITE,
  ADD_OR_EDIT_FAVORITES,
  MY_FAVORITES
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmF2b3JpdGVzLmpzIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZ3JhcGhxbC9mYXZvcml0ZXMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGdxbCBmcm9tIFwiZ3JhcGhxbC10YWdcIjtcblxuZXhwb3J0IGNvbnN0IE1ZX0ZBVk9SSVRFUyA9IGdxbGBcbiAgcXVlcnkgKFxuICAgICR3aGVyZTogRmF2b3JpdGVzRmlsdGVySW5wdXRcbiAgICAkb3JkZXI6IFtGYXZvcml0ZXNTb3J0SW5wdXQhXVxuICAgICRza2lwOiBJbnRcbiAgICAkdGFrZTogSW50XG4gICkge1xuICAgIG15RmF2b3JpdGVzKHdoZXJlOiAkd2hlcmUsIG9yZGVyOiAkb3JkZXIsIHNraXA6ICRza2lwLCB0YWtlOiAkdGFrZSkge1xuICAgICAgX19wYWdlSW5mbzogcGFnZUluZm8ge1xuICAgICAgICBoYXNOZXh0UGFnZVxuICAgICAgfVxuICAgICAgX19pdGVtczogaXRlbXMge1xuICAgICAgICBpZFxuICAgICAgICBuYW1lXG4gICAgICB9XG4gICAgfVxuICB9XG5gO1xuXG5leHBvcnQgY29uc3QgQUREX09SX0VESVRfRkFWT1JJVEUgPSBncWxgXG4gIG11dGF0aW9uICgkaW5wdXQ6IEZhdm9yaXRlc0lucHV0ISkge1xuICAgIGFkZE9yRWRpdEZhdm9yaXRlKGlucHV0OiAkaW5wdXQpIHtcbiAgICAgIGlkXG4gICAgfVxuICB9XG5gO1xuXG5leHBvcnQgY29uc3QgQUREX09SX0VESVRfRkFWT1JJVEVTID0gZ3FsYFxuICBtdXRhdGlvbiAoJGlucHV0czogW0Zhdm9yaXRlc0lucHV0IV0hKSB7XG4gICAgYWRkT3JFZGl0RmF2b3JpdGVzKGlucHV0czogJGlucHV0cykge1xuICAgICAgaWRcbiAgICB9XG4gIH1cbmA7XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUVPLE1BQU0sZUFBZTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFtQnJCLE1BQU0sdUJBQXVCO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBUTdCLE1BQU0sd0JBQXdCO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOyJ9
